// get ids from an array of objects or numbers
export const getIds = <T extends { id: number } | number>(value?: T[] | number[]) => {
	if (!value?.length) {
		return [];
	}

	if (typeof value[0] === 'number') {
		return value as number[];
	}

	return (value as Array<T & { id: number }>).map((item) => item.id);
};
